import React, { useState } from "react";
import PropTypes from "prop-types";
import { purple } from "@material-ui/core/colors";
import { Grid, TextField, InputAdornment } from "@material-ui/core";
import { makeStyles, createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { removerCaracteresControle } from "../../utils/formatacoes";
 
const tema = createMuiTheme({
  palette: {
    primary: {
      main: purple["A200"]
    }
  },
  typography: {
    fontFamily: "CircularStd-Book"
  }
});

const EntradaTexto = props => {
  const {
    proriedadesPersonalizadas,
    ativarErroComportamento,
    endAdornmentIcon,
    quantidadeLinhas,
    maximoCaracteres,
    campoRequerido,
    mensagemErro,
    placeholder,
    tabIndex,
    disabled,
    onChange,
    etiqueta,
    estilos,
    mascara,
    value,
    autoFocus,
    setAutoFocus,
    id,
    onBlur,
    onPaste
  } = props;
  const classes = useStyles(props);
  const [focusOut, setStateFocus] = useState(false);

  const funcaoOnBlur = () => {
    setStateFocus(true);
    setAutoFocus && setAutoFocus(false);
    onBlur && onBlur();
  };

  const focus = input => {
    if (input) {
      input.focus();
    }
  };

  const InputCustomProps = {
    endAdornment: endAdornmentIcon && (
      <InputAdornment position="end">{endAdornmentIcon}</InputAdornment>
    )
  };

  const inputCustomProps = {
    onPaste: onPaste
  };

  const propriedadesFocus = autoFocus
    ? {
      variant: "outlined",
      inputRef: focus
    }
    : {
      variant: "outlined"
    };

  const propriedadesEntrada = mascara
    ? {
      InputProps: {
        inputComponent: mascara,
        inputProps: { tabIndex: tabIndex },
        ...InputCustomProps
      },
      inputProps: inputCustomProps
    }
    : { inputProps: { maxLength: maximoCaracteres, tabIndex: tabIndex, ...inputCustomProps } };

  const valorTratado = value || "";

  const handleChange = (event, ...args) => {
    if (onChange &&
      event && event.target) {

      let valor = event.target.value;
      valor = removerCaracteresControle(valor);

      event.target.value = valor;
      onChange(event, ...args);
    }
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <ThemeProvider theme={tema}>
          <TextField
            {...proriedadesPersonalizadas}
            {...propriedadesEntrada}
            {...propriedadesFocus}
            error={
              ativarErroComportamento || (campoRequerido && focusOut &&
                (typeof (valorTratado) === "string" && valorTratado.trim().length === 0))
            }
            helperText={mensagemErro && mensagemErro.length > 0 ? mensagemErro : null}
            onBlur={() => funcaoOnBlur()}
            multiline={quantidadeLinhas > 1}
            className={classes.entrada}
            placeholder={placeholder}
            required={campoRequerido}
            rows={quantidadeLinhas}
            value={valorTratado}
            onChange={handleChange}
            disabled={Boolean(disabled)}
            variant="outlined"
            label={etiqueta}
            style={estilos}
            id={id}
            InputProps={{
              classes: {
                disabled: classes.disabled
              }
            }}
          />
        </ThemeProvider>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  entrada: {
    width: "100%"
  },
  notchedOutline: {},
  focused: {
    "& $notchedOutline": {
      borderColor: "#e040fb !important"
    }
  },
  floatingLabelFocusStyle: {
    color: "#9b2caf !important"
  },
  disabled: {
    "&$disabled": {
      backgroundColor: "rgba(192, 192, 222, 0.3)",
      borderRadius: "5px",
    }
  }
});

EntradaTexto.propTypes = {
  proriedadesPersonalizadas: PropTypes.object,
  ativarErroComportamento: PropTypes.bool,
  maximaCaracteres: PropTypes.number,
  quantidadeLinhas: PropTypes.number,
  campoRequerido: PropTypes.bool,
  mensagemErro: PropTypes.string,
  textoAjuda: PropTypes.string,
  etiqueta: PropTypes.string,
  estilos: PropTypes.object,
  onChange: PropTypes.func,
  mascara: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  id: PropTypes.string,
  onPaste: PropTypes.func,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  setAutoFocus: PropTypes.func
};

EntradaTexto.defaultProps = {
  proriedadesPersonalizadas: {},
  ativarErroComportamento: false,
  maximaCaracteres: null,
  campoRequerido: false,
  quantidadeLinhas: 1,
  mensagemErro: "",
  textoAjuda: null,
  onChange: null,
  mascara: null,
  etiqueta: "",
  estilos: {},
  value: "",
  id: "",
  onBlur: null,
  onPaste: null,
  endAdornmentIcon: null,
  disabled: false,
  autoFocus: false
};

export default EntradaTexto;
